const UNIT_NUMBER_SPLIT = /^\s*([A-Za-z]+)\s*-\s*(.*)\s*$/;

type UnitSortParts = {
  prefix: string;
  prefixGroup: number;
  prefixAlphaRank: number;
  suffixNumber: number;
  suffixTail: string;
  raw: string;
};

function prefixGroupRank(prefix: string): number {
  if (prefix === 'G') return 0;
  if (prefix === 'F') return 1;
  if (/^[A-Z]+$/.test(prefix)) return 2;
  return 3;
}

function parseUnitSortParts(input: unknown): UnitSortParts {
  const raw = String(input || '').trim();
  const match = raw.match(UNIT_NUMBER_SPLIT);
  const prefix = String(match?.[1] || '').trim().toUpperCase();
  const suffixRaw = String(match?.[2] || raw).trim();
  const suffixNumberMatch = suffixRaw.match(/\d+/);
  const suffixNumber = suffixNumberMatch ? Number(suffixNumberMatch[0]) : Number.POSITIVE_INFINITY;
  const suffixTail = suffixRaw.replace(/^\d+/, '').trim().toUpperCase();
  const prefixGroup = prefixGroupRank(prefix);
  const prefixAlphaRank =
    prefixGroup === 2 && prefix.length > 0 ? prefix.charCodeAt(0) : Number.POSITIVE_INFINITY;
  return {
    prefix,
    prefixGroup,
    prefixAlphaRank,
    suffixNumber,
    suffixTail,
    raw: raw.toUpperCase(),
  };
}

export function compareUnitNumbers(left: unknown, right: unknown): number {
  const a = parseUnitSortParts(left);
  const b = parseUnitSortParts(right);

  if (a.prefixGroup !== b.prefixGroup) return a.prefixGroup - b.prefixGroup;
  if (a.prefix !== b.prefix) {
    if (a.prefixGroup === 2 && b.prefixGroup === 2) return a.prefixAlphaRank - b.prefixAlphaRank;
    return a.prefix.localeCompare(b.prefix, undefined, { numeric: true, sensitivity: 'base' });
  }
  if (a.suffixNumber !== b.suffixNumber) return a.suffixNumber - b.suffixNumber;
  if (a.suffixTail !== b.suffixTail) {
    return a.suffixTail.localeCompare(b.suffixTail, undefined, { numeric: true, sensitivity: 'base' });
  }
  return a.raw.localeCompare(b.raw, undefined, { numeric: true, sensitivity: 'base' });
}
